import OngoingParty from '@pages/gamers/ongoing-party/ongoing-party';
export default OngoingParty;
